(function () {
  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var target = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!target) return;
      var isOpen = target.hasAttribute('open');
      if (isOpen) {
        target.removeAttribute('open');
      } else {
        target.setAttribute('open', '');
      }
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants-json]');
    var inventoryJson = form.querySelector('[data-variant-inventory-json]');
    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector('[data-add-to-cart]');
    var quantityInput = form.querySelector('[data-quantity-input]');
    var quantityNote = form.querySelector('[data-quantity-note]');
    if (!json || !idInput || !submit) return;

    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (error) {
      return;
    }

    var inventory = [];
    if (inventoryJson) {
      try {
        inventory = JSON.parse(inventoryJson.textContent);
      } catch (error) {
        inventory = [];
      }
    }

    function selectedOptions() {
      return Array.from(form.querySelectorAll('[data-option-group]')).map(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function inventoryLimitForVariant(variant) {
      if (!variant) return null;

      var item = inventory.find(function (entry) {
        return String(entry.id) === String(variant.id);
      });

      if (!item || !item.inventory_management || item.inventory_policy === 'continue') {
        return null;
      }

      var quantity = Number(item.inventory_quantity);
      return quantity > 0 ? quantity : null;
    }

    function clampQuantity(limit) {
      if (!quantityInput) return;

      var min = Number(quantityInput.getAttribute('min')) || 1;
      var value = Number(quantityInput.value);
      if (!Number.isFinite(value) || value < min) {
        value = min;
      }

      if (limit && value > limit) {
        value = limit;
      }

      quantityInput.value = String(value);
    }

    function applyQuantityLimit(variant) {
      var limit = inventoryLimitForVariant(variant);

      if (quantityInput) {
        if (limit) {
          quantityInput.setAttribute('max', String(limit));
        } else {
          quantityInput.removeAttribute('max');
        }
        clampQuantity(limit);
      }

      if (quantityNote) {
        if (limit) {
          var template = quantityNote.dataset.template || 'Max. [quantity] verfuegbar';
          quantityNote.textContent = template.replace('[quantity]', String(limit));
          quantityNote.hidden = false;
        } else {
          quantityNote.hidden = true;
        }
      }
    }

    function updateVariant() {
      var options = selectedOptions();
      var variant = variants.length === 1 && options.length === 0
        ? variants[0]
        : variants.find(function (item) {
          return item.options.every(function (option, index) {
            return option === options[index];
          });
        });

      if (!variant) {
        submit.disabled = true;
        submit.textContent = submit.dataset.unavailableText;
        applyQuantityLimit(null);
        return;
      }

      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldOutText;
      applyQuantityLimit(variant);
    }

    form.addEventListener('change', updateVariant);
    if (quantityInput) {
      quantityInput.addEventListener('input', function () {
        var currentVariant = variants.find(function (item) {
          return String(item.id) === String(idInput.value);
        });
        applyQuantityLimit(currentVariant);
      });
    }
    updateVariant();
  });

  var revealTargets = document.querySelectorAll('.product-card, .feature-card, .section-header, .product__media, .xuna-lookbook__item');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    revealTargets.forEach(function (target) {
      target.classList.add('reveal-on-scroll');
      revealObserver.observe(target);
    });
  } else {
    revealTargets.forEach(function (target) {
      target.classList.add('is-visible');
    });
  }

  document.querySelectorAll('[data-product-lightbox]').forEach(function (dialog) {
    var image = dialog.querySelector('[data-lightbox-image]');
    var frame = dialog.querySelector('.product-lightbox__frame');
    var closeButton = dialog.querySelector('[data-lightbox-close]');
    if (!image || !frame || !closeButton) return;
    var opener;
    var previousOverflow;
    image.draggable = false;
    document.querySelectorAll('[data-lightbox-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-label', 'Produktbild ansehen');
      trigger.addEventListener('click', function () {
        opener = trigger;
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        image.src = trigger.dataset.lightboxSrc;
        image.alt = trigger.dataset.lightboxAlt || '';
        dialog.showModal();
      });
    });
    closeButton.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target === frame) dialog.close();
    });
    dialog.addEventListener('close', function () {
      document.body.style.overflow = previousOverflow || '';
      image.removeAttribute('src');
      if (opener) opener.focus({ preventScroll: true });
    });
  });
})();
